import { render, staticRenderFns } from "./SporeSerie.vue?vue&type=template&id=949c40fe&scoped=true"
import script from "./SporeSerie.vue?vue&type=script&lang=js"
export * from "./SporeSerie.vue?vue&type=script&lang=js"
import style0 from "./SporeSerie.vue?vue&type=style&index=0&id=949c40fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949c40fe",
  null
  
)

export default component.exports